import { COLOR_PALETTE } from 'constants/ui';

export const programDetailsWrapperStyles = {
  width: '100%',
  gap: 3,
};

export const getProgramDetailsStyles = () => ({
  flexDirection: 'row',
  gap: 3,
  width: '100%',
  p: 3,
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) => palette.background.secondary,
});

export const ratesTableStyles = {
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderBottom: 'none',
};

export const additionalTableStyles = {
  ...ratesTableStyles,
  '& .MuiTableCell-root': {
    p: '15px',
    fontSize: 14,
    fontWeight: ({ typography }) => typography.fontWeightRegular,
    lineHeight: '22px',
    color: ({ palette }) => palette.text.dark,

    '&.MuiTableCell-head, &.total': {
      fontWeight: ({ typography }) => typography.fontWeightBold,
    },
  },
};

export const secondColumnStyles = {
  gap: 3,
  flex: 1,
};

export const headRowRatesStyles = {
  height: 62,
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderBottom: 'none',
};

export const headCellStyles = {
  maxWidth: 100,
  p: 2,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '16px',
  borderBottom: `1px solid ${COLOR_PALETTE.BRAND[6]}`,
};

export const firstHeadCellStyles = {
  ...headCellStyles,
  width: 100,
  borderRight: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const totalAdjustmentsStyles = {
  justifyContent: 'space-between',
  p: 1.5,
  backgroundColor: ({ palette }) => palette.background.secondary,
  borderRadius: '8px',

  '& .MuiTypography-root': {
    fontSize: 18,
    fontWeight: ({ typography }) => typography.fontWeightMedium,
    lineHeight: '21px',

    '&.amount': {
      color: '#3E83DC',
    },
  },
};

export const secondColumnItemStyles = {
  flex: 0,
};

export const ratesheetStateStyles = {
  py: 2,
};

export const additionalInfoListStyles = {
  m: 0,
  pl: 3,
};

export const expiredPriceWarningStyles = {
  gap: 1,
  alignItems: 'center',
};

export const expiredPriceWarningIconStyles = {
  color: 'warning.main',
};

export const investorWarningsStyles = {
  gap: 1,
};

export const investorWarningIconStyles = {
  display: 'flex',
  color: 'info.main',
};
